import { css } from '@emotion/core';

export const styWrapper = css`
  padding: 3em 0;
  background-color: #f9f9f9;
  
  h2 {
    margin-bottom: 1.5em;
    color: #2f2f2f;
  }
  
  p {
    color: #666;
  }
`;

export const styFooterSection = css`
  padding: 2em 0;
  background-color: #333;
  color: #fff;
  text-align: center;
  
  h3 {
    margin-bottom: 1em;
  }
  
  p {
    margin-bottom: 2em;
  }
  
  a {
    color: #fff;
    text-decoration: none;
  }
`;

export const styPhysicalAddress = css`
  margin-bottom: 2.5em;
  
  .address-container {
    padding: 1.5em;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    max-width: 600px;
    margin: 0 auto;
    transition: all 0.3s ease;
    
    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
    }
  }
  
  .address-title {
    color: #2f2f2f;
    font-size: 1.3em;
    margin-bottom: 0.8em;
    font-weight: 600;
  }
  
  .address-text {
    font-size: 1.1em;
    color: #666;
    line-height: 1.6;
  }
  
  @media (max-width: 768px) {
    .address-title {
      font-size: 1.1em;
    }
    
    .address-text {
      font-size: 1em;
    }
  }
`;

export const styBankAccount = css`
  margin-bottom: 2em;
  
  .bank-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 1.5em;
    padding: 1.5em;
    border-radius: 8px;
    background-color: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    
    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
    }
  }
  
  .bank-logo {
    margin-bottom: 1em;
    
    img {
      height: 30px;
      width: auto;
      max-width: 100%;
    }
  }
  
  .bank-content {
    text-align: center;
    width: 100%;
    
    h3 {
      font-size: 1.2em;
      margin-bottom: 0.5em;
      color: #2f2f2f;
    }
    
    .account-number {
      font-family: monospace;
      font-size: 1.1em;
      background-color: #f5f5f5;
      padding: 0.5em 1em;
      border-radius: 4px;
      margin: 0;
      word-break: break-all;
    }
    
    .crypto-address {
      font-size: 0.9em;
      overflow-wrap: break-word;
      word-wrap: break-word;
      word-break: break-word;
      hyphens: auto;
    }
  }
  
  .crypto-item {
    max-width: 500px;
    margin-left: auto;
    margin-right: auto;
  }
  
  @media (max-width: 768px) {
    .bank-content {
      .account-number {
        font-size: 0.9em;
        padding: 0.5em;
      }
      
      .crypto-address {
        font-size: 0.8em;
      }
    }
  }
`;